import React, { useRef, Children } from 'react';
import { motion, useScroll, useTransform, useInView } from 'framer-motion';
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export function NarrativeSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(contentRef, {
    once: true,
    margin: '-80px'
  });
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], [30, -30]);
  return <section ref={sectionRef} className="w-full bg-light px-6 py-20 md:py-26" aria-label="Property description" data-id="element-109">
      <motion.div ref={contentRef} className="mx-auto max-w-3xl" style={{
      y: parallaxY
    }} data-id="element-110">
        <motion.div className="mb-12" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={fadeUpVariants} data-id="element-111">
          <p className="font-heading text-xs font-bold tracking-widest-plus uppercase text-accent mb-4" data-id="element-112">
            The Opportunity
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-dark" data-id="element-113">
            Prime City Fringe Warehouse
          </h2>
        </motion.div>

        <motion.div className="space-y-6" initial="hidden" animate={isInView ? 'visible' : 'hidden'} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.15,
            delayChildren: 0.15
          }
        }
      }} data-id="element-114">
          <motion.p className="font-body text-base md:text-lg leading-relaxed text-dark/80" variants={fadeUpVariants} data-id="element-115">
            Positioned in the heart of North Melbourne's dynamic mixed-use
            precinct, 120-124 Dryburgh Street presents a rare opportunity to
            secure a high-exposure warehouse facility on the doorstep of the
            CBD. This versatile 355 sqm* property combines functional industrial
            utility with exceptional future potential.
          </motion.p>

          <motion.p className="font-body text-base md:text-lg leading-relaxed text-dark/80" variants={fadeUpVariants} data-id="element-116">
            The asset features a commanding 14-metre* frontage to Dryburgh
            Street, providing excellent brand visibility and access. Internally,
            the clear-span warehouse offers generous clearance heights ranging
            from 4.1m* to 6.6m*, accessed via a container-height roller door.
            Rear access adds further operational flexibility for logistics or
            dual-occupancy potential (STCA).
          </motion.p>

          <motion.p className="font-body text-base md:text-lg leading-relaxed text-dark/80" variants={fadeUpVariants} data-id="element-117">
            Whether for immediate occupation, strategic investment, or adaptive
            reuse, this property sits at the convergence of connectivity and
            lifestyle. With short-term holding income available, it offers the
            perfect window to plan your next move in one of Melbourne's most
            tightly held commercial markets.
          </motion.p>
        </motion.div>
      </motion.div>
    </section>;
}